import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    excluir(processo) {
        return axiosJwt.delete(`${api}/contratos/${processo.contratoId}/processosjudiciais/${processo.idProcessoJudicialContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(processo) {
        const formData = new FormData()
        formData.append('codigo', processo.codigo)
        formData.append('descricao', processo.descricao)
        formData.append('documento', processo.documento)
        
        return axiosJwt
            .post(`${api}/contratos/${processo.idContrato}/processosjudiciais`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizar(idContrato, processo) {
        const formData = new FormData()
        formData.append('codigo', processo.codigo)
        formData.append('descricao', processo.descricao)
        formData.append('idProcessoJudicialContrato', processo.idProcessoJudicialContrato)

        return axiosJwt
            .put(`${api}/contratos/${idContrato}/processosjudiciais`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProcessos(idContrato) {
        return axiosJwt.get(`${api}/contratos/${idContrato}/processosjudiciais`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterProcesso(idContrato, idProcessoJudicialContrato) {
        return axiosJwt.get(`${api}/contratos/${idContrato}/processosjudiciais/${idProcessoJudicialContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    download(processo) {
        return axiosJwt
            .get(`${api}/contratos/${processo.idContrato}/processosjudiciais/${processo.idProcessoJudicialContrato}/download`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
